import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/login/phone/lms`;

export const ROUTE: RouteDefinition = `${baseRoute}/login/phone/lms`;

export const URL = (): RouteDefinition => `${baseRoute}/login/phone/lms`;
